import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

import { useRejectReturn } from './useRejectReturn'
import { Popup, confirmPopup } from '@/components/popup'

interface RejectReturnModalProps {
  returnId: string
  open: boolean
  onClose: () => void
}

interface RejectFormValues {
  rejectionReason: string
}

export function RejectReturnModal({ returnId, open, onClose }: RejectReturnModalProps) {
  const { t } = useTranslation()
  const [form] = Form.useForm<RejectFormValues>()
  const { rejectReturn, isRejecting } = useRejectReturn(() => {
    form.resetFields()
    onClose()
  })

  const handleOk = () => {
    void form.validateFields().then((values) => {
      confirmPopup({
        title: t('common.modals.rejectReturnTitle'),
        content: t('common.modals.rejectReturnMessage'),
        okText: t('common.buttons.confirm'),
        cancelText: t('common.buttons.cancel'),
        okButtonProps: { 'data-testid': 'reject-return-confirm-ok-btn' },
        cancelButtonProps: { 'data-testid': 'reject-return-confirm-cancel-btn' },
        onOk: () => {
          rejectReturn(returnId, values.rejectionReason)
        },
      })
    })
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Popup
      data-testid="reject-return-modal"
      title={t('common.modals.rejectReturnTitle')}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={isRejecting}
      okText={t('common.buttons.reject')}
      cancelText={t('common.buttons.cancel')}
      okButtonProps={{ 'data-testid': 'reject-return-modal-ok-btn' }}
      cancelButtonProps={{ 'data-testid': 'reject-return-modal-cancel-btn' }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="rejectionReason"
          label={t('pages.returns.fields.rejectionReason')}
          rules={[{ required: true, whitespace: true }]}
        >
          <Input.TextArea
            data-testid="reject-return-reason-input"
            rows={3}
            placeholder={t('pages.returns.rejectionReasonPlaceholder')}
          />
        </Form.Item>
      </Form>
    </Popup>
  )
}
